import { Trans } from '@lingui/react'

import IconCross from 'views/components/atoms/Icon/IconCross'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ButtonSmall from 'views/components/molecules/ButtonSmall'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

export const closeComponentForModal = () => (
  <>
    <ButtonSmall
      name="modal-close-button"
      href="#"
      primary
      data-clientside-hook="refinementList__close-modal"
      ariaHidden="true"
    >
      <TextWithIcon icon={<IconCross />}>
        <span className="u-visuallyhidden@small-tiny">
          <Trans id="general.link.label.close" />
        </span>
      </TextWithIcon>
    </ButtonSmall>
    <ButtonAsLink
      name="modal-cancel-selection"
      href="#"
      data-clientside-hook="refinementList__cancel-selection"
      ariaHidden="true"
    >
      <Trans id="general.link.label.back" />
    </ButtonAsLink>
  </>
)
